import React from "react";
import "./MarqueeBar.css";

const MarqueeBar = ({ text }) => (
  <div className="home-marquee-container">
    <div className="home-marquee-content">
      <p>{text}</p>
    </div>
  </div>
);

export default MarqueeBar;